import {
  NOTIFICATION_STACKS,
  NotificationStackId,
} from "@/constants/notification";
import {
  NotificationType,
  useNotificationStore,
} from "@/store/useNotificationStore";
import {
  CHANNEL_REPAIR_COPY,
  CHANNEL_WINDOW_CLOSE_DEFERRED_COPY,
  CHANNEL_WINDOW_CLOSE_REPAIR_COPY,
  TUTOR_AUDIO_DEFERRED_COPY,
  CHANNEL_WARNING_COPY,
} from "@/features/tutor/utils/chatSettingsPersistence";
import type { ChannelVerdict } from "@/features/tutor/store/useChatSettingsStore";
import type { OutputChannel } from "@/features/tutor/utils/chatSettingsPersistence";

export const CHANNEL_WARNING_MS = 15000;

const announce = (message: string): void => {
  const { notifications, removeNotification, showNotification } =
    useNotificationStore.getState();

  notifications
    .filter((n) => n.type === NotificationType.CHANNEL_WARNING)
    .forEach((n) => removeNotification(n.id));

  showNotification(
    message,
    NotificationType.CHANNEL_WARNING,
    CHANNEL_WARNING_MS,
    NOTIFICATION_STACKS[NotificationStackId.TOP_CENTER],
  );
};

export const announceChannelRefusal = (verdict: ChannelVerdict): void => {
  if (verdict.allowed) return;
  announce(CHANNEL_WARNING_COPY[verdict.attempted]);
};

/**
 * The guardrail turning audio back on by itself, when the caption surface
 * disappears under a student who had muted. Manual refusals are announced; this
 * repair was not, so the tutor simply started speaking aloud unprompted.
 */
export const announceChannelRepair = (): void => announce(CHANNEL_REPAIR_COPY);

export const announceWindowCloseRepair = (restored: OutputChannel): void =>
  announce(CHANNEL_WINDOW_CLOSE_REPAIR_COPY[restored]);

export const announceWindowCloseDeferred = (): void =>
  announce(CHANNEL_WINDOW_CLOSE_DEFERRED_COPY);

export const announceTutorAudioDeferred = (): void =>
  announce(TUTOR_AUDIO_DEFERRED_COPY);
